module.exports = __webpack_public_path__ + "img/service_고령친화금융산업.0e395ce8.png";